/**
 * expires (GMT)
 */

const deleteCookie = (key, path, domain) => document.cookie = `${key}=; Path=${path}; Domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

export default deleteCookie;